import { ref, get } from 'firebase/database';
import { db } from './firebase';

/** RTDB path written by scripts/sync-channels-to-firebase.mjs */
export const CHANNELS_CACHE_PATH = 'channels_cache';

/**
 * Load channel snapshot from Firebase (daily sync target).
 * @returns {Promise<{ countries: Object, categories: Object, countriesMetadata: Object, updatedAt: number | null } | null>}
 */
export async function fetchChannelsFromFirebaseCache() {
  const snapshot = await get(ref(db, CHANNELS_CACHE_PATH));
  if (!snapshot.exists()) return null;
  const val = snapshot.val();
  if (!val || typeof val !== 'object') return null;
  const { countries, categories, countriesMetadata, updatedAt } = val;
  if (!countries || !categories) return null;
  return {
    countries,
    categories,
    countriesMetadata: countriesMetadata || {},
    updatedAt: typeof updatedAt === 'number' ? updatedAt : null,
  };
}
